import React from 'react';

import usePreCompInstructorStudentRatioDropdown from './UsePreCompInstructorStudentRatioDropdown';

import Dropdown from '@usas/ui-web/components/dropdowns/Dropdown';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const PreCompInstructorStudentRatioDropdown = ({ label, name, value, error, message, onChange }) => {
  const { preCompInstructorStudentRatioState } = usePreCompInstructorStudentRatioDropdown();

  return preCompInstructorStudentRatioState.message
    ? <span className={global.LoadingMsg}>{preCompInstructorStudentRatioState.message}</span>
    : (
      <Dropdown
        error={error}
        label={label}
        message={message}
        options={preCompInstructorStudentRatioState.dataAsOptionsWithNames}
        name={name}
        value={value}
        onChange={onChange}
        isLoading={preCompInstructorStudentRatioState.isLoading}
      />
    );
};

export default PreCompInstructorStudentRatioDropdown;